module.exports = __webpack_public_path__ + "img/service-zhunongjinrong3.8c8caf20.svg";